import React, {useMemo} from "react";
import {useParams} from "react-router-dom";
import {useAppSelector} from "../../../../../redux";
import FormResponsesView from "../../../operator/forms-management/responses";

/**
 * Customer-scoped form responses (filters locked to the current customer).
 */
const CustomerFormResponsesPage = () => {
    const params = useParams();
    const defaultCustomer = useAppSelector((state) => state.customerInformation);

    const customerId = useMemo(() => Number(params.customerId), [params.customerId])

    const name = defaultCustomer?.name ?? "";
    const pageTitle = `${name ?? "Customer"}'s Form responses`;

    /**
     * Configures notebook tags to filter form responses by the current customer.
     * @type {function(*): *}
     */
    const notebookTagConfigurator = useMemo(() => (noteTags) => noteTags.customerFormResponses(defaultCustomer?.code), [defaultCustomer?.code]);

    return (
        <FormResponsesView
            fixedCustomerId={customerId}
            pageTitle={pageTitle}
            notebookTagConfigurator={notebookTagConfigurator}
        />
    );
};

export default CustomerFormResponsesPage;
